import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

import { TeamListModel } from './team-list.model';
import { TeamModel } from './team.model';

/**
 * HTTP client for the monolith Teams endpoints. One method per controller endpoint; owns URL
 * composition and verbs off `origin.monolith`.
 */
@Injectable({ providedIn: 'root' })
export class TeamsApiService {
  private readonly http = inject(HttpClient);
  private readonly monolith = inject(ENVIRONMENT).origin.monolith;

  getTeamsLite(): Observable<TeamListModel[]> {
    return this.http.get<TeamListModel[]>(`${this.monolith}/TeamsLite`);
  }

  getTeam(id: string): Observable<TeamModel> {
    return this.http.get<TeamModel>(`${this.monolith}/Teams/${id}`);
  }

  updateTeam(id: string, update: Partial<TeamModel>): Observable<void> {
    return this.http.patch<void>(`${this.monolith}/Teams/${id}`, update);
  }
}
